module.exports = __webpack_public_path__ + "img/cegep-sorel-tracy.40d0f3fb.png";